import { makeVar } from '@apollo/client';
import { Address, PluginSettings } from 'gql/__generated/vp-apollo';
import { pluginSettingsService } from '@cobra/services/plugin-settings.service';

const settings = pluginSettingsService.syncLoad<PluginSettings>('availability-check');

export const pluginSettingsVar = makeVar<PluginSettings>(settings);
export const addressToCheckVar = makeVar<Address | null | undefined>(settings.address);
